var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-form-item" },
    [
      [
        _c(
          "label",
          {
            staticClass: "hkl-form-item_label",
            class: { "required-flag": _vm.canEdit ? _vm.required : false },
          },
          [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]
        ),
      ],
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hkl-form-item_body" },
        [_c("HKLFormItemContent", [_vm._t("default")], 2)],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }